module.exports = __webpack_public_path__ + "media/images/covid/mainImg_mobile-2f8c8a22861175985d56893679192db4.jpg";